import { AsyncPipe, CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatTable,
} from '@angular/material/table'
import { NgxPaginationModule } from 'ngx-pagination'
import { SearchComponent } from '../../components/search/search.component'
import { Address } from '../../models/location.interface'
import { catchError, map, Observable, switchMap, tap } from 'rxjs'
import { Pagination } from '../../models/pagination.interface'
import { LayoutService } from '../../services/layout/layout.service'
import { ActivatedRoute, Router } from '@angular/router'
import { ToastrService } from 'ngx-toastr'
import { MatDialog } from '@angular/material/dialog'
import { AddressService } from '../../services/address/address.service'
import { Filter, QueryGet } from '../../shared/query-types'
import { PAGINATION } from '../../shared/constants'
import { AddressFormComponent } from '../address-form/address-form.component'
import { LoadingService } from '../../services/loadingService/loading.service'
import { OnlysuperuserDirective } from '../../directives/onlysuperuser.directive'
import { Title } from '@angular/platform-browser'

@Component({
    selector: 'app-address-list',
    standalone: true,
    imports: [
        CommonModule,
        MatIcon,
        MatTable,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCellDef,
        MatCell,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        NgxPaginationModule,
        AsyncPipe,
        SearchComponent,
        OnlysuperuserDirective,
    ],
    templateUrl: './address-list.component.html',
    styleUrl: './address-list.component.css',
})
export class AddressListComponent {
    public page: number | undefined
    @Input() filtro: string = ''
    @Input() orden: string = ''
    limit = 10
    total = 0
    addressList: Address[] = []
    selectedAddress: Address | null = null
    asyncAddress!: Observable<Pagination<Address[]>>
    showColumns: string[] = [
        'acciones',
        'outsider',
        'authorityCode',
        'authority',
        'territoryCode',
        'territory',
        'address',
        'geoRef',
    ]

    constructor(
        private layoutService: LayoutService,
        private activatedRouter: ActivatedRoute,
        private addressService: AddressService,
        private router: Router,
        private toastr: ToastrService,
        private dialog: MatDialog,
        private title: Title,
        private loadingService: LoadingService
    ) {this.title.setTitle('Dirección')}

    fetchAddress(page: number, filter: Filter | null = null, search = '') {
        const offset = page > 1 ? page * this.limit - this.limit : 0
        const params: QueryGet = {
            order: '-id',
            limit: this.limit,
            offset,
            search,
            filters: [],
        }
        if (filter) {
            params.filters.push(filter)
        }
        this.page = page
        this.loadingService.show(true)
        this.asyncAddress = this.addressService.allAddresses(params).pipe(
            tap((response) => {
                this.addressList = response.results
                this.addressService.setAddress(response.results)
                this.total = response.count
            }),
            map((res) => {
                this.loadingService.show(false)
                return res
            }),
            catchError((error) => {
                this.loadingService.show(false)
                this.router.navigate(['home/'])
                return []
            })
        )
    }

    ngOnInit(): void {
        this.layoutService.paginationLimit$
            .pipe(
                switchMap((limit) => {
                    this.limit = limit
                    return this.activatedRouter.queryParamMap
                }),
                switchMap((params) => {
                    const pageNum = params.get('page') || '1'
                    const search = params.get('search') || ''
                    this.page = parseInt(pageNum)
                    this.fetchAddress(PAGINATION.first_page, null, search)
                    return this.layoutService.paginationLimit$
                })
            )
            .subscribe()
    }

    eliminate(address: Address): void {
        const confirmed = window.confirm(
            `¿Estás seguro de eliminar la dirección: ${address.territory}`
        )
        if (!confirmed) return
        this.addressService.deleteAddress(address.id).subscribe({
            next: () => {
                const successMsg = `La dirección fue eliminada CORRECTAMENTE!`
                this.toastr.success(successMsg, 'Exitoso!', {
                    progressBar: true,
                    timeOut: 5000,
                })
                this.fetchAddress(PAGINATION.first_page)
            },
            error: (err) => {
                this.toastr.error('No se pudo eliminar la dirección', 'Error')
            },
        })
    }

    updateAddress(address: Address) {
        this.addressService.setAddresses(address)
        const dialogRef = this.dialog.open(AddressFormComponent, {
            data: { selectedAddress: this.selectedAddress },
            width: '90vw',
            maxWidth: '80vw',
            maxHeight: '80vh',
        })
        dialogRef.afterClosed().subscribe(() => {
            this.fetchAddress(PAGINATION.first_page)
        })
    }
}
